import React from 'react';
import { connect } from 'react-redux';
import { validatePermission } from '../../../../../utils/auth';
import GridImportantNoteCell from '../../../../shared/GridImportantNoteCell/GridImportantNoteCell';

class ImportantNoteCell extends React.Component {

    render() {
        const { rowDetail, user, activeDepartment } = this.props;
        const hasPermission = activeDepartment?.isDelegate || validatePermission('EDIT_JO', user.roleName);
        
        return <GridImportantNoteCell
            rowDetail={rowDetail}
            importantNote={rowDetail.value}
            readOnly={!hasPermission}
        />
    }
};

const mapStateToProps = state => ({
    user: state.session.user,
    activeDepartment: state.session.activeDepartment
})

export default connect(mapStateToProps)(ImportantNoteCell);